<template>
  <v-container
    :pa-3="$vuetify.breakpoint.xsOnly"
  >
    <v-layout>
      <v-flex xs12 md6>
        <v-card
          color="blue-grey darken-1"
          class="white--text"
          :style="'max-width: 600px'"
        >
          <v-card-title primary-title>
            <div class="headline">Feed for "{{ _.get(search, 'name') }}"</div>
            <div>Below you can find latest mentions from press, social media and alternative media</div>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              color="primary"
              @click="edit = !edit"
            >
              <v-icon>{{ edit ? 'cancel' : 'edit' }}</v-icon>
            </v-btn>
            <v-btn
              icon
              dark
              color="error"
              @click="remove()"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
        <search-form
          :search="search"
          v-show="edit"
        ></search-form>
      </v-flex>
    </v-layout>
    <v-layout
      mt-4
    >
      <mention-list
        :search="search"
      ></mention-list>
    </v-layout>
  </v-container>
</template>

<script>
  import mixinsPages from '@/mixins/pages'
  import SearchForm from '@/components/search/SearchForm'
  import MentionList from '@/components/search/MentionList'

  export default {
    title: 'Feed',
    mixins: [mixinsPages],
    data () {
      return {
        edit: false,
        articles: []
      }
    },
    methods: {
      remove () {
        this.$axios.post('/saved-search/delete', {id: this.id})
        this.$store.commit('search/removeSearch', this.id)
        this.$router.push({name: 'dashboard'})
      }
    },
    computed: {
      id () {
        return this.$route.params.id
      },
      search () {
        return this.$store.getters['search/search'](this.id)
      }
    },
    components: {
      SearchForm,
      MentionList
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/search/search-view.vue